<template>
  <v-card :color="cardColor" @click="$emit('click')">
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  props: {
    cardColor: {
      type: String,
      default: 'primary'
    },
  },
}
</script>
